module.exports = __webpack_public_path__ + "img/angular.fe73175a.svg";